import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import AuthService from '../../state/auth.service';
import AuthUtils from '../../AuthUtils';

const Subnav = props => {
    const isOrgAdmin = (user, orgId) => {
        let access = AuthUtils.getAccesses(user.resource);
        console.log(access);
        if ((access.consultant && !access.consultantRestricted) || (access.organizations && access.organizations[orgId] === 'Administrator')) {
            return true;
        }
        return false;
    };

    const isConsultant = user => {
        let access = AuthUtils.getAccesses(user.resource);
        if (access.consultantRestricted === true) {
            return false;
        }
        return access.consultant;
    };

    const isRestrictedUser = user => {
        let access = AuthUtils.getAccesses(user.resource);
        return access.consultantRestricted;
    };

    const isGeneralViewer = user => {
        return user.role === 'General Viewer';
    };

    const hasOrganizations = user => {
        let access = AuthUtils.getAccesses(user.resource);
        return access.organizations;
    };

    const isARestrictedUserAndNotAGeneralUser = () => {
        /*
         * Checking a few things here.
         * 1) Is the user a restricted user?
         * 2) Does this user have any organizations? (Annual or Initial)
         * 3) A General Viewer also has access.consultantRestricted = true.
         * Use the user.role to determine if it is a "General Viewer".
         */
        const user = AuthService.getUser();
        return isRestrictedUser(user) && hasOrganizations(user) && !isGeneralViewer(user);
    };

    const isPracticeLimited = (user, practiceId) => {
        let access = AuthUtils.getAccesses(user.resource);
        console.log(access);
        if (access.practices && access.practices[practiceId]) {
            return true;
        }
    };

    const renderBreadCrumbs = orgId => {
        return (
            <ul className="Subnav__breadcrumb">
                <li className="home">
                    <Link to="/">
                        <i className="fa fa-home" /> &raquo;
                    </Link>
                </li>
                <li>
                    <Link to={`/organization/${orgId}`}>
                        <i className="fa fa-sitemap" /> Organization
                    </Link>
                </li>
            </ul>
        );
    };

    const renderTopLevelSubNav = () => {
        const user = AuthService.getUser();
        if (isConsultant(user)) {
            return (
                <ul className="Subnav__admin">
                    <li className="Subnav__consultant-admin">
                        <Link to="/consultant/team">Manage Consultancy Team</Link>
                    </li>
                    <li className="Subnav__consultant-admin">
                        <Link to="/consultant/organizations">Manage Organizations</Link>
                    </li>
                    <li className="Subnav__consultant-admin">
                        <Link to="/consultant/activitylogs">Activity Logs</Link>
                    </li>
                </ul>
            );
        } else if (isARestrictedUserAndNotAGeneralUser()) {
            return (
                <ul className="Subnav__admin">
                    <li className="Subnav__consultant-admin">
                        <Link to="/consultant/activitylogs">Activity Logs</Link>
                    </li>
                </ul>
            );
        } else return null;
    };

    const getTopLevelNav = () => {
        const { filterId } = props;
        return (
            <div className="Subnav">
                <ul className="Subnav__breadcrumb">
                    {filterId ? (
                        renderBreadCrumbs(filterId)
                    ) : (
                        <li className="home">
                            <Link to="/">
                                <i className="fa fa-home"></i>{' '}
                            </Link>
                        </li>
                    )}
                </ul>
                {renderTopLevelSubNav()}
            </div>
        );
    };

    const renderOrganizationLevelSubNav = organizationId => {
        const user = AuthService.getUser();
        if (isConsultant(user) || isARestrictedUserAndNotAGeneralUser() || isOrgAdmin(user, organizationId)) {
            return (
                <ul className="Subnav__admin">
                    <li>
                        <Link to={`/organization/${organizationId}/practices`}>Manage Practices</Link>
                    </li>
                    <li>
                        <Link to={`/organization/${organizationId}/team`}>Manage Team</Link>
                    </li>
                    <li>
                        <Link to={`/organization/${organizationId}/schedule`}>Manage Deadline Plan</Link>
                    </li>
                    <li>
                        <Link to={`/organization/${organizationId}/plan`}>Manage Criteria Plan</Link>
                    </li>
                    <li>
                        <Link to={`/organization/${organizationId}/files`}>Files</Link>
                    </li>
                    <li className="Subnav__consultant-admin">
                        <Link to={`/consultant/activitylogs/${organizationId}`}>Activity Logs</Link>
                    </li>
                </ul>
            );
        }
    };

    const getOrganizationLevelNav = organizationId => {
        return (
            <div className="Subnav">
                {renderBreadCrumbs(organizationId)}
                <ul className="Subnav__main">
                    <li>
                        <Link to={`/organization/${organizationId}/status`}>Status</Link>
                    </li>
                </ul>
                {renderOrganizationLevelSubNav(organizationId)}
            </div>
        );
    };

    const getPracticeLevelNav = (organizationId, practiceId) => {
        const user = AuthService.getUser();
        return (
            <div className="Subnav">
                <ul className="Subnav__breadcrumb">
                    <li className="home">
                        <Link to="/">
                            <i className="fa fa-home" /> &raquo;
                        </Link>
                    </li>
                    <li className={`${isPracticeLimited(user, practiceId) ? 'hidden' : ''}`}>
                        <Link to={`/organization/${organizationId}`}>
                            <i className={`fa fa-sitemap`} /> Organization &raquo;
                        </Link>
                    </li>
                    <li>
                        <Link to={`/practice/${practiceId}`}>
                            <i className="fa fa-stethoscope" /> Practice
                        </Link>
                    </li>
                </ul>

                {isConsultant(user) || isOrgAdmin(user, organizationId) ? (
                    <ul className="Subnav__admin">
                        <li>
                            <Link to={`/organization/${organizationId}/practices`}>Manage Practices</Link>
                        </li>
                        <li>
                            <Link to={`/organization/${organizationId}/team`}>Manage Team</Link>
                        </li>
                        <li>
                            <Link to={`/organization/${organizationId}/schedule`}>Manage Deadline Plan</Link>
                        </li>
                        <li>
                            <Link to={`/organization/${organizationId}/plan`}>Manage Criteria Plan</Link>
                        </li>
                    </ul>
                ) : null}
            </div>
        );
    };

    const organizationId = props.organizationId;
    const practiceId = props.practiceId;

    if (practiceId) {
        return getPracticeLevelNav(organizationId, practiceId);
    } else if (organizationId) {
        return getOrganizationLevelNav(organizationId);
    }
    return getTopLevelNav();
};

export default withRouter(Subnav);
